import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class PayoutBatchStatusFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <select
                className="filter-input"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
            >
                <option value="RUNNING,COMPLETE,CANCELED"></option>
                <option value="RUNNING">RUNNING</option>
                <option value="COMPLETE">COMPLETE</option>
                <option value="CANCELED">CANCELED</option>
            </select>
        );
    }
}
